import type { TolgeeInstance } from "@tolgee/web";
import type { SupportedLocale } from "./locale";
import { buildRouteHead, type LearnSeo, type RouteHead } from "./seo";

/**
 * 라우트 `head()` 어댑터 — __root beforeLoad가 컨텍스트에 넣은 locale과 요청별 Tolgee로
 * `buildRouteHead`(src/lib/seo.ts)를 호출한다. 루트 라우트(전 경로)와 learn 글 라우트
 * (post 포함)가 쓴다.
 */
export function routeHeadFromContext(
	context: { locale: SupportedLocale; tolgee: TolgeeInstance },
	pathname: string,
	extra?: { learnSeo?: LearnSeo; notFound?: boolean },
): RouteHead {
	return buildRouteHead({
		pathname,
		locale: context.locale,
		t: (key, params) => context.tolgee.t(key, params),
		...extra,
	});
}
